import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
export function NewSheetModal({ onClose, onCreate }) {
    const tribeRef = useRef(null);
    const qRef = useRef(null);
    const yRef = useRef(null);
    const handleCreate = () => {
        onCreate(tribeRef.current?.value ?? 'I', qRef.current?.value ?? '3', yRef.current?.value ?? '2026');
    };
    return (_jsx("div", { style: {
            position: 'fixed',
            inset: 0,
            background: 'rgba(15,23,42,.45)',
            zIndex: 50,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }, children: _jsxs("div", { "data-menu-keep": "1", style: {
                width: 340,
                background: '#FFFFFF',
                borderRadius: 14,
                padding: 20,
                display: 'flex',
                flexDirection: 'column',
                gap: 14,
                boxShadow: '0 20px 60px rgba(15,23,42,.3)',
            }, children: [_jsx("div", { style: { fontSize: 16, fontWeight: 700 }, children: "\u041D\u043E\u0432\u044B\u0439 \u043B\u0438\u0441\u0442" }), _jsxs("label", { style: { display: 'flex', flexDirection: 'column', gap: 6, fontSize: 12, fontWeight: 600, color: '#334155' }, children: ["\u0422\u0440\u0430\u0439\u0431", _jsxs("select", { ref: tribeRef, defaultValue: "I", style: {
                                height: 36,
                                border: '1px solid #CBD5E1',
                                borderRadius: 8,
                                padding: '0 10px',
                                fontSize: 13,
                                background: '#FFFFFF',
                            }, children: [_jsx("option", { value: "I", children: "I" }), _jsx("option", { value: "V", children: "V" }), _jsx("option", { value: "M", children: "M" }), _jsx("option", { value: "AM", children: "AM" }), _jsx("option", { value: "\u041C\u041F", children: "\u041C\u041F" })] })] }), _jsxs("div", { style: { display: 'flex', gap: 10 }, children: [_jsxs("label", { style: { flex: 1, display: 'flex', flexDirection: 'column', gap: 6, fontSize: 12, fontWeight: 600, color: '#334155' }, children: ["\u041A\u0432\u0430\u0440\u0442\u0430\u043B", _jsxs("select", { ref: qRef, defaultValue: "3", style: {
                                        height: 36,
                                        border: '1px solid #CBD5E1',
                                        borderRadius: 8,
                                        padding: '0 10px',
                                        fontSize: 13,
                                        background: '#FFFFFF',
                                    }, children: [_jsx("option", { value: "1", children: "Q1" }), _jsx("option", { value: "2", children: "Q2" }), _jsx("option", { value: "3", children: "Q3" }), _jsx("option", { value: "4", children: "Q4" })] })] }), _jsxs("label", { style: { flex: 1, display: 'flex', flexDirection: 'column', gap: 6, fontSize: 12, fontWeight: 600, color: '#334155' }, children: ["\u0413\u043E\u0434", _jsxs("select", { ref: yRef, defaultValue: "2026", style: {
                                        height: 36,
                                        border: '1px solid #CBD5E1',
                                        borderRadius: 8,
                                        padding: '0 10px',
                                        fontSize: 13,
                                        background: '#FFFFFF',
                                    }, children: [_jsx("option", { value: "2026", children: "2026" }), _jsx("option", { value: "2027", children: "2027" })] })] })] }), _jsxs("div", { style: { display: 'flex', justifyContent: 'flex-end', gap: 8 }, children: [_jsx("button", { type: "button", onClick: onClose, className: "kp-cancel-btn", style: {
                                height: 34,
                                padding: '0 14px',
                                border: '1px solid #E2E8F0',
                                borderRadius: 8,
                                background: '#FFFFFF',
                                color: '#475569',
                                fontSize: 13,
                                fontWeight: 600,
                                cursor: 'pointer',
                            }, children: "\u041E\u0442\u043C\u0435\u043D\u0430" }), _jsx("button", { type: "button", onClick: handleCreate, className: "kp-primary-btn", style: {
                                height: 34,
                                padding: '0 16px',
                                border: 'none',
                                borderRadius: 8,
                                background: '#2563EB',
                                color: '#FFFFFF',
                                fontSize: 13,
                                fontWeight: 600,
                                cursor: 'pointer',
                            }, children: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C" })] })] }) }));
}
